import { axiosInstance } from "authProvider";
import { API_URL } from "../../constants";

export const getContainers =
  (populate: boolean = true) =>
  async (): Promise<[]> => {
    const fields = populate ? "populate=*" : "fields=name,id,type";
    return await axiosInstance
      .get(`${API_URL}/api/containers?${fields}`)
      .then(({ data }) => data);
  };
